goog.provide('el8.ptdata.model.guarantor');

goog.require('el8.model.base');

(function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);

    _class.addStringProperty('relationship', true); // null === self
    _class.addStringProperty('firstName', true);
    _class.addStringProperty('lastName', true);
    _class.addStringProperty('middleName', true);
    _class.addStringProperty('address', true);
    _class.addStringProperty('suite', true);
    _class.addStringProperty('city', true);
    _class.addStringProperty('state', true);
    _class.addStringProperty('zip', true);
    _class.addStringProperty('phone', true);

    el8.ptdata.model.guarantor = function(spec) { return new _class(spec); };

})();
